import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/workspace-sheet';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { ClipboardList, Package } from 'lucide-react';
import { useMaterialRequestStore } from '../store';

export function MaterialRequestDetailSheet() {
  const { detailSheetOpen, selectedRequest, closeDetailSheet } =
    useMaterialRequestStore();

  if (!selectedRequest) return null;

  const handleCreatePicklist = () => {
    // TODO: Implement picklist creation when backend is ready
    console.log('Create picklist for MR:', selectedRequest.id);
    closeDetailSheet();
  };

  return (
    <Sheet open={detailSheetOpen} onOpenChange={(open) => !open && closeDetailSheet()}>
      <SheetContent side="right" className="w-full sm:max-w-xl flex flex-col overflow-hidden">
        <SheetHeader className="flex-shrink-0">
          <SheetTitle className="flex items-center gap-2">
            <ClipboardList className="h-5 w-5" />
            {selectedRequest.mrsNumber}
          </SheetTitle>
          <SheetDescription>
            Requested by {selectedRequest.requestorFullName}
          </SheetDescription>
        </SheetHeader>

        <div className="flex-1 flex flex-col min-h-0 mt-4">
          {/* Request Summary */}
          <div className="grid grid-cols-2 gap-4 text-sm mb-4">
            <div>
              <span className="text-muted-foreground">Employee ID:</span>
              <span className="ml-2 font-medium">{selectedRequest.requestorIdNumber}</span>
            </div>
            <div>
              <span className="text-muted-foreground">Approved By:</span>
              <span className="ml-2 font-medium">{selectedRequest.approvedBy}</span>
            </div>
            <div>
              <span className="text-muted-foreground">Requested:</span>
              <span className="ml-2 font-medium">
                {new Date(selectedRequest.requestedAt).toLocaleDateString()}
              </span>
            </div>
            <div>
              <span className="text-muted-foreground">Items:</span>
              <span className="ml-2 font-medium">{selectedRequest.items.length}</span>
            </div>
          </div>

          <Separator className="my-2" />

          {/* Items List */}
          <h4 className="font-medium mb-2 flex items-center gap-2">
            <Package className="h-4 w-4" />
            Items ({selectedRequest.items.length})
          </h4>

          <div className="flex-1 overflow-y-auto -mx-6 px-6">
            <div className="space-y-3">
              {selectedRequest.items.map((item) => (
                <div
                  key={item.id}
                  className="p-3 border rounded-lg bg-muted/30"
                >
                  <div className="flex justify-between items-start">
                    {/* 86d48d39v: ItemName is uncapped in the DB — bound the render */}
                    <div className="min-w-0">
                      <p className="font-medium truncate">{item.itemName}</p>
                      <p className="text-sm text-muted-foreground">{item.itemCode}</p>
                    </div>
                    <Badge variant="outline">
                      {item.requestedQuantity} {item.unitOfMeasure}
                    </Badge>
                  </div>
                  {item.releasedQuantity > 0 && (
                    <p className="text-sm text-muted-foreground mt-1">
                      Released: {item.releasedQuantity} / {item.requestedQuantity}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>

          <Separator className="my-4" />

          {/* Action Buttons */}
          <div className="flex gap-2 justify-end flex-shrink-0">
            <Button variant="outline" onClick={closeDetailSheet}>
              Close
            </Button>
            <Button onClick={handleCreatePicklist}>
              Create Picklist
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
